export enum PeriodContext {
  generic = 'generic',
  invoiceVoid = 'invoiceVoid',
  invoice = 'invoice'
}
